import { Component, OnInit } from '@angular/core';
import { FormBuilder, Validators, FormControl, FormGroup } from '@angular/forms';
import { Store } from '@ngrx/store';
import { AppState } from 'src/app/app.reducer';
import { ChangePassword, ClearAction, ChangePasswordByAdmin } from '../../user-management/store/user-managment.actions';
import { GetConfigurations } from '../../configurations/store/configurations.actions';
import { Router, ActivatedRoute } from '@angular/router';
import { MatDialog } from '@angular/material';
import { OtpScreenComponent } from 'src/app/dialogs/otp-screen/otp-screen.component';
import { SendOtpToAdminMail, Logout } from 'src/app/login/store/auth.actions';
import { VerifyChangePhoneComponent } from '../change-phone/verify-change-phone/verify-change-phone.component';
import { Location } from '@angular/common';
import { take, takeUntil } from 'rxjs/operators';
import { Subject } from 'rxjs';

@Component({
    selector: 'app-change-password',
    templateUrl: './change-password.component.html',
    styleUrls: ['./change-password.component.scss']
})
export class ChangePasswordComponent implements OnInit {
    changePasswordform: FormGroup;
    passwordLength = 0;
    specialCharCountLength = 0;
    showCurrentPasswordField: boolean = false;
    endPoint: string = '';
    email: any;
    phone: string;
    countryCode: string;
    userIdParam;
    updadatePasswordByAdmin;
    userId: string;
    configObj: any;
    passwordEntered: any;
    numRegex: RegExp;
    upperCaseregex: RegExp;
    specialCharregex: RegExp;
    wrongPasswordFormat: boolean;
    stopper$: Subject<any> = new Subject();
    passwordValidationMsg: string = 'Password must contain a minimum of 7 characters and a maximum of 15 characters and at least one special character (*, /, @, #, etc.)and at least one uppercase character and at least two digits';
    token: any;
    showCurrPassword: boolean = false;
    showNewPassword: boolean = false;
    showConfirmPassword: boolean = false;
    sentOtp = false;
    otpScreenOpened: boolean = false; // this flag is enabled to prevent opening new otp pop's on top of the existing one on click of resend otp button
    otherUserDetails: any = {}

    constructor(
        private fb: FormBuilder,
        public store: Store<AppState>,
        private router: Router,
        private dialog: MatDialog,
        public route: ActivatedRoute,
        private location: Location
    ) {
        this.endPoint = this.router.url.split('/').pop();
        // this.route.firstChild.paramMap.subscribe(param => {
        //     this.userIdParam = param['params'].id
        //     console.log(this.userIdParam, "here")
        // })  
        if (this.endPoint) {
            this.store.select(state => state.userManagment.userDetails).subscribe(res => {
                this.otherUserDetails = res
            })
        }
    }

    ngOnInit() {
        this.store.select(state => state.auth).pipe(take(1)).subscribe(auth => {
            this.token = auth.accessToken;
            this.userId = auth.user.details._id;
        });

        this.route.params.subscribe((params) => {
            this.userIdParam = params.id;
            if (this.userIdParam != undefined) {
                this.updadatePasswordByAdmin = true;
            } else {
                this.updadatePasswordByAdmin = false;
            }
        });



        // this.store.dispatch(new GetConfigurations());
        // this.store.select(state => state.configurations.configurations).subscribe((response) => {
        //     let index = Object.keys(response).findIndex((key) => key === 'passwordLength');
        //     if (index !== -1) {
        //         this.passwordLength = response['passwordLength'].value;
        //     }

        //     let indexCount = Object.keys(response).findIndex((key) => key === 'specialCharCount');
        //     if (indexCount !== -1) {
        //         this.specialCharCountLength = response['specialCharCount'].value;
        //     }

        this.changePasswordform = this.fb.group({
            oldPassword: ['', [Validators.required]],
            newPassword: [
                '',
                Validators.compose([
                    Validators.required,
                    // Validators.maxLength(20),
                    // Validators.minLength(this.passwordLength),
                    // Validators.pattern(
                    //     "(?=.*?[#?!@$%^&*-]).{" + this.specialCharCountLength + ",}"
                    // ),
                ])
            ],
            confirmpwd: [
                '',
                Validators.compose([
                    Validators.required,
                    this.fieldMatcher('newPassword', 'passwordMismatchCustom'),
                ]),
            ],
        });
        // });

        this.showCurrentPasswordField = (['change-password', 'edit'].includes(this.endPoint)) ? true : false;
        this.store.select(state => state.auth.user).subscribe((res) => {
            this.email = res.details.email || '';
            this.phone = res.details.phone || '';
            this.countryCode = res.details.countryCode || '';
        });

        this.store.dispatch(new GetConfigurations);
        this.store.select(state => state.configurations.configurations).pipe(takeUntil(this.stopper$)).subscribe((resp: any) => {
            if (Object.keys(resp).length) {
                console.log("here", resp);
                this.configObj = resp;
                const passwordMinLength = +resp['passwordMinLength'].value;
                const passwordMaxLength = +resp['passwordMaxLength'].value;
                this.changePasswordform.get('newPassword').setValidators([
                    Validators.required,
                    Validators.minLength(passwordMinLength),
                    Validators.maxLength(passwordMaxLength),
                ])

                this.passwordValidationMsg = `Password must contain a minimum of ${passwordMinLength} characters and a
                maximum of ${passwordMaxLength} characters`

                if (resp['specialCharCount'].value != 0) {
                    this.passwordValidationMsg += ` and atleast ${+resp['specialCharCount'].value} special character(s) (*, /, @, #, etc.)`
                }
                if (resp['upperCaseCount'].value != 0) {
                    this.passwordValidationMsg += ` and atleast ${+resp['upperCaseCount'].value} uppercase character(s)`
                }
                if (resp['numCount'].value != 0) {
                    this.passwordValidationMsg += ` and atleast ${+resp['numCount'].value} digit(s)`
                }

            }
        })

        this.changePasswordform.get('newPassword').valueChanges.subscribe((password) => {
            let upperCaseCount = parseInt(this.configObj['upperCaseCount'].value);
            let specialCharCount = parseInt(this.configObj['specialCharCount'].value);
            let passwordMaxLength = parseInt(this.configObj['passwordMaxLength'].value);
            let passwordMinLength = parseInt(this.configObj['passwordMinLength'].value);
            let numCount = parseInt(this.configObj['numCount'].value);
            this.passwordEntered = password;

            this.numRegex = new RegExp(`((.*[0-9]){${numCount},}.*)`);
            this.upperCaseregex = new RegExp(`((.*[A-Z]{${upperCaseCount},}.*))`)
            this.specialCharregex = new RegExp(`(.*[^A-Za-z0-9]){${specialCharCount},}.*`)
            if (password.length >= passwordMinLength && password.length <= passwordMaxLength) {
                if (this.numRegex.test(password)) {
                    this.wrongPasswordFormat = false;
                    if (this.upperCaseregex.test(password)) {
                        this.wrongPasswordFormat = false;
                        if (this.specialCharregex.test(password)) {
                            this.wrongPasswordFormat = false;
                        } else {
                            this.wrongPasswordFormat = true;
                        }
                    } else {
                        this.wrongPasswordFormat = true;
                    }
                } else {
                    this.wrongPasswordFormat = true;
                }
            } else {
                this.wrongPasswordFormat = true;
            }
        })
    }

    fieldMatcher(field: string, errorKey: string) {
        return function (control: FormControl): { [s: string]: boolean } {
            if (!control.parent) return null;
            return control.parent.get(field).value === control.value
                ? null
                : { [errorKey]: true };
        };
    }

    restrictSpace(event: KeyboardEvent) {
        let x = event.keyCode;
        if (x == 32) {
            return false;
        }
    }

    changePassword() {
        if (!this.showCurrentPasswordField) {
            this.changePasswordform.removeControl('oldPassword');
        }
        if (this.changePasswordform.invalid) {
            return false;
        }

        console.log(this.updadatePasswordByAdmin);

        if (this.showCurrentPasswordField) {

            const payload = {
                old_password: this.changePasswordform.value.oldPassword,
                new_password: this.changePasswordform.value.newPassword
            }

            this.store.dispatch(new ClearAction());
            this.store.dispatch(new ChangePassword(payload));
            this.store.select(state => state.userManagment.changePassRes).subscribe(response => {
                if (Object.keys(response).length && !this.sentOtp && !this.otpScreenOpened) {
                    this.sentOtp = true;
                    if (!response.bypass_otp) {
                        this.otpScreenOpened = true;
                        const dialogRef = this.dialog.open(VerifyChangePhoneComponent, {
                            hasBackdrop: true,
                            width: '700px',
                            height: '500px',
                            panelClass: 'cmp-modal',
                            data: {
                                alertTitle: 'Enter OTP',
                                registeredEmail: this.email,
                                countryCode: this.countryCode,
                                phone: this.phone,
                                type: 'changePassword',
                                oldPass: this.changePasswordform.value.oldPassword,
                                newPass: this.changePasswordform.value.newPassword
                            }
                        });
                        dialogRef.afterClosed().subscribe((rsp: any) => {
                            this.sentOtp = false;
                            this.otpScreenOpened = false;
                        });
                    }
                    else {
                        this.store.dispatch(new Logout(this.userId, this.token));
                    }
                }
            })

        } else {
            console.log(this.endPoint)
            const payload = {
                password: this.changePasswordform.value.newPassword
            }

            this.store.dispatch(new SendOtpToAdminMail(payload, this.endPoint))
            if (!this.otpScreenOpened) {
                this.otpScreenOpened = true;
                const dialogRef = this.dialog.open(OtpScreenComponent, {
                    width: '700px',
                    height: '500px',
                    panelClass: 'cmp-modal',
                    data: {
                        alertTitle: "OTP",
                        alertText: `OTP has been sent to ${this.otherUserDetails['email']}`,
                        id: this.endPoint,
                        byAdmin: true,
                        type: "changePassword",
                        password: this.changePasswordform.value.newPassword,
                        endPoint: this.endPoint
                    }
                });
                dialogRef.afterClosed().subscribe((response: any) => {
                    if (response) {
                        this.changePasswordform.reset()
                    }
                    this.otpScreenOpened = false;
                })
            }

        }

    }

    showPasswordFunction(type) {
        switch (type) {
            case 'current':
                this.showCurrPassword = !this.showCurrPassword;
                break;
            case 'new':
                this.showNewPassword = !this.showNewPassword;
                break;
            case 'confirm':
                this.showConfirmPassword = !this.showConfirmPassword;
                break;
            default:
                break;
        }
    }

    ngOnDestroy() {
        this.stopper$.next();
        this.stopper$.complete();
    }
}
